import http from 'conversations-http/clients/http';
export const sendHeartbeat = ({
  features
}) => http.post('messages/v2/presence/heartbeat', {
  data: {
    features
  }
});